import { render, staticRenderFns } from "./TicketDataTable.vue?vue&type=template&id=61cb51f6&scoped=true&"
import script from "./TicketDataTable.vue?vue&type=script&lang=ts&"
export * from "./TicketDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./TicketDataTable.vue?vue&type=style&index=0&id=61cb51f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb51f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61cb51f6')) {
      api.createRecord('61cb51f6', component.options)
    } else {
      api.reload('61cb51f6', component.options)
    }
    module.hot.accept("./TicketDataTable.vue?vue&type=template&id=61cb51f6&scoped=true&", function () {
      api.rerender('61cb51f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketDataTable.vue"
export default component.exports